<template>
    <div>
        <div v-if="!isHelpdeskMenuOpen" class="helpdesk">
            <button class="helpdesk-button" @click="toogleHelpdeskMenu()">
                <common-icon name="support" size="extra-huge"></common-icon>
            </button>
        </div>
        <transition name="slide">
            <div v-if="isHelpdeskMenuOpen">
                <div v-click-away="toogleHelpdeskMenu" class="helpdesk-menu" @click.stop>
                    <div class="helpdesk-menu--header">
                        <div class="helpdesk-menu--header--close" @click="toogleHelpdeskMenu()">
                            <common-icon name="arrow-down" size="huge"></common-icon>
                        </div>
                        <div class="helpdesk-menu--header--icon">
                            <common-icon name="support" size="gigantic"></common-icon>
                        </div>
                        <p class="helpdesk-button__title">
                            {{ $t('components.helpdesk.helpdesk.help') }}
                        </p>
                    </div>
                    <helpdesk-options :options="options"></helpdesk-options>
                    <div class="helpdesk-menu--contact">
                        <common-buttons class="helpdesk-menu--contact-buttons">
                            <common-button
                                icon="location"
                                :isSubmittable="false"
                                :label="$t('pages.contact.contact.heading')"
                                type="tertiary"
                                size="tiny"
                                @click="goToContactUs()"
                            ></common-button>
                            <common-button
                                icon="location"
                                :isSubmittable="false"
                                :label="$t('pages.contact.contact.support')"
                                type="tertiary"
                                size="tiny"
                                @click="goToSupportReservation()"
                            ></common-button>
                        </common-buttons>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import RoutesEnum from 'enums/routes.enum'
    import HelpdeskOptions from 'components/page-elements/helpdesk/HelpdeskOptions'
    import LanguageEnum from 'enums/language.enum'

    export default {
        components: { HelpdeskOptions },

        data() {
            return {
                isHelpdeskMenuOpen: false,
                prevOptions: [],
                videoName: undefined,
                RoutesEnum,
            }
        },

        computed: {
            language() {
                return this.$i18n.locale === LanguageEnum.EN ? 'eng' : this.$i18n.locale === LanguageEnum.RU ? 'ru' : 'srb'
            },
            options() {
                return [
                    {
                        name: this.$t('components.helpdesk.helpdesk.options.companies'),
                        childs: [
                            {
                                name: this.$t('components.helpdesk.helpdesk.options.company_registration'),
                                value: `https://bookeraj-static-contents.s3.eu-central-1.amazonaws.com/promo/video-guide/${this.language}/dodavanje-kompanije-${this.language}.mp4`,
                            },
                            {
                                name: this.$t('components.helpdesk.helpdesk.options.company_users'),
                                value: `https://bookeraj-static-contents.s3.eu-central-1.amazonaws.com/promo/video-guide/${this.language}/dodavanje-korisnika-${this.language}.mp4`,
                            },
                            {
                                name: this.$t('components.helpdesk.helpdesk.options.inactivity_setup'),
                                value: `https://bookeraj-static-contents.s3.eu-central-1.amazonaws.com/promo/video-guide/${this.language}/dodavanje-neaktivnosti-${this.language}.mp4`,
                            },
                            {
                                name: this.$t('components.helpdesk.helpdesk.options.create_discount'),
                                value: `https://bookeraj-static-contents.s3.eu-central-1.amazonaws.com/promo/video-guide/${this.language}/dodavanje-popusta-${this.language}.mp4`,
                            },
                        ],
                    },
                    {
                        name: this.$t('components.helpdesk.helpdesk.options.users'),
                        childs: [
                            {
                                name: this.$t('components.helpdesk.helpdesk.options.company_users'),
                                value: `https://bookeraj-static-contents.s3.eu-central-1.amazonaws.com/promo/video-guide/${this.language}/dodavanje-korisnika-${this.language}.mp4`,
                            },
                            {
                                name: this.$t('components.helpdesk.helpdesk.options.inactivity_setup'),
                                value: `https://bookeraj-static-contents.s3.eu-central-1.amazonaws.com/promo/video-guide/${this.language}/dodavanje-neaktivnosti-${this.language}.mp4`,
                            },
                            {
                                name: this.$t('components.helpdesk.helpdesk.options.create_discount'),
                                value: `https://bookeraj-static-contents.s3.eu-central-1.amazonaws.com/promo/video-guide/${this.language}/dodavanje-popusta-${this.language}.mp4`,
                            },
                        ],
                    },
                    {
                        name: this.$t('components.helpdesk.helpdesk.options.offers'),
                        childs: [
                            {
                                name: this.$t('components.helpdesk.helpdesk.options.create_offer'),
                                value: `https://bookeraj-static-contents.s3.eu-central-1.amazonaws.com/promo/video-guide/${this.language}/dodavanje-usluge-${this.language}.mp4`,
                            },
                            {
                                name: this.$t('components.helpdesk.helpdesk.options.offer_actions'),
                                value: `https://bookeraj-static-contents.s3.eu-central-1.amazonaws.com/promo/video-guide/${this.language}/dodavanje-korisnika-na-raspored-${this.language}.mp4`,
                            },
                        ],
                    },
                ]
            },
        },

        methods: {
            toogleHelpdeskMenu() {
                this.isHelpdeskMenuOpen = !this.isHelpdeskMenuOpen
            },
            goToContactUs() {
                this.toogleHelpdeskMenu()
                this.$router.push({ name: RoutesEnum.CONTACT.CONTACT })
            },
            goToSupportReservation() {
                this.toogleHelpdeskMenu()
                this.$router.push({ name: RoutesEnum.OFFER.SINGLE, params: { id: 314, offerType: 'details' } })
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/components/helpdesk/helpdesk.scss';
</style>
